/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {ViewContainerRef} from '@angular/core';
import {LayoutDirection} from '../core';

/** Valid ARIA roles for a dialog element. */
export type DialogRole = 'dialog' | 'alertdialog';

/** Possible overrides for a dialog's position. */
export interface DialogPosition {
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
}
/**
 * Configuration for opening a modal dialog with the MdDialog service.
 */
export class MdDialogConfig {
/**
 * Where the attached component should live in Angular's *logical* component tree.
 * This affects what is available for injection and the change detection order for the
 * component instantiated inside of the dialog. This does not affect where the dialog
 * content will be rendered.
 */
viewContainerRef?: ViewContainerRef;
/**
 * The ARIA role of the dialog element.
 */
role?: DialogRole = 'dialog';
/**
 * Custom class for the overlay pane.
 */
panelClass?: string = '';
/**
 * Whether the dialog has a backdrop.
 */
hasBackdrop?: boolean = true;
/**
 * Custom class for the backdrop,
 */
backdropClass?: string = '';
/**
 * Whether the user can use escape or clicking outside to close a modal.
 */
disableClose?: boolean = false;
/**
 * Width of the dialog.
 */
width?: string = '';
/**
 * Height of the dialog.
 */
height?: string = '';
/**
 * Position overrides.
 */
position?: DialogPosition;
/**
 * Data being injected into the child component.
 */
data?: any = null;
/**
 * Layout direction for the dialog's content.
 */
direction?: LayoutDirection = 'ltr';

  // TODO(jelbourn): add configuration for lifecycle hooks, ARIA labelling.
}

function MdDialogConfig_tsickle_Closure_declarations() {
/**
 * Where the attached component should live in Angular's *logical* component tree.
 * This affects what is available for injection and the change detection order for the
 * component instantiated inside of the dialog. This does not affect where the dialog
 * content will be rendered.
 * @type {?}
 */
MdDialogConfig.prototype.viewContainerRef;
/**
 * The ARIA role of the dialog element.
 * @type {?}
 */
MdDialogConfig.prototype.role;
/**
 * Custom class for the overlay pane.
 * @type {?}
 */
MdDialogConfig.prototype.panelClass;
/**
 * Whether the dialog has a backdrop.
 * @type {?}
 */
MdDialogConfig.prototype.hasBackdrop;
/**
 * Custom class for the backdrop,
 * @type {?}
 */
MdDialogConfig.prototype.backdropClass;
/**
 * Whether the user can use escape or clicking outside to close a modal.
 * @type {?}
 */
MdDialogConfig.prototype.disableClose;
/**
 * Width of the dialog.
 * @type {?}
 */
MdDialogConfig.prototype.width;
/**
 * Height of the dialog.
 * @type {?}
 */
MdDialogConfig.prototype.height;
/**
 * Position overrides.
 * @type {?}
 */
MdDialogConfig.prototype.position;
/**
 * Data being injected into the child component.
 * @type {?}
 */
MdDialogConfig.prototype.data;
/**
 * Layout direction for the dialog's content.
 * @type {?}
 */
MdDialogConfig.prototype.direction;
}

